import React, {memo} from "react";
import Breadcrumbs from "@/app/components/breadcrumbs";
import {BreadcrumbsType} from "@/app/components/breadcrumbs/widget";
import Space from "@/app/components/space";
import Input from "@/app/components/input";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import LazyAssets from "@/app/utils/assets_widget";
import ChatItem from "@/app/components/chat_item/widget";
import {TextMedium14, ThirtyText} from "@/app/components/texts";
import Button from "@/app/components/button";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import {ScreenState} from "@/app/features/chats/slice";
import {ChatModel} from "@/app/api/chat";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface Props {
  state: ScreenState;
  search: (query: string) => void;
  goToMain: () => void,
  onSelectChat: (chat: ChatModel) => void;
  loadMoreChats: () => void;
}

const ChatsList: React.FC<Props> = ({state, search, goToMain, onSelectChat, loadMoreChats}) => {
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    // Проверяем, достиг ли пользователь конца списка (с небольшим отступом в 100px)
    if (scrollHeight - scrollTop <= clientHeight + 100) {
      loadMoreChats();
    }
  };

  return (
    <div className={classNames(styles.chatListWrapper, {[styles.withOutChats]: state.selectedChat === undefined})}>
      <Breadcrumbs items={[BreadcrumbsType.chats]}/>
      <Input
        hint={t(s.search)}
        onChange={search}
        prefixIcon={<LazyAssets.Search/>}
      />
      {state.chats !== undefined && state.chats.length > 0 && <div className={styles.chatList} onScroll={handleScroll}>
        {state.chats.map((chat, index) => (
          <ChatItem key={index} item={chat} onSelectChat={() => onSelectChat(chat)} unreadMessageCount={chat.unreadMessageCount}/>
        ))}
        {state.loading && <div style={{display: 'flex', justifyContent: 'center', padding: '16px'}}>
          <CircularProgressIndicator isGreen/>
        </div>}
      </div>}
      {state.chats !== undefined && state.chats.length === 0 && <div className={styles.emptyPage}>
          <ThirtyText text={t(s.noChatsYet)}/>
          <TextMedium14 text={t(s.findCompanyToPlay)}/>
          <Button text={t(s.findPlayers)} isViolet onClick={goToMain}/>
      </div>}
      {state.chats === undefined && <div className={styles.emptyPage}>
          <CircularProgressIndicator isGreen/>
      </div>}
    </div>
  );
};

export default memo(ChatsList);